export const ArrowLeftFullIcon = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_892_288)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M1.49012e-08 10.0001C1.49012e-08 9.54922 0.365482 9.18373 0.816327 9.18373H19.1837C19.6345 9.18373 20 9.54922 20 10.0001C20 10.4509 19.6345 10.8164 19.1837 10.8164H0.816327C0.365482 10.8164 1.49012e-08 10.4509 1.49012e-08 10.0001Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M9.96499 0.851401C10.2838 1.1702 10.2838 1.68707 9.96499 2.00586L1.97079 10.0001L9.96499 17.9943C10.2838 18.3131 10.2838 18.8299 9.96499 19.1487C9.64619 19.4675 9.12932 19.4675 8.81053 19.1487L0.239097 10.5773C-0.0796988 10.2585 -0.0796988 9.74163 0.239097 9.42283L8.81053 0.851401C9.12932 0.532606 9.64619 0.532606 9.96499 0.851401Z'
          fill='currentColor'
        />
      </g>
      <defs>
        <clipPath id='clip0_892_288'>
          <rect width='20' height='20' fill='none' />
        </clipPath>
      </defs>
    </svg>
  )
}
